module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/add-registration/add-registration.component.css
// module id = ./src/app/shared/components/add-registration/add-registration.component.css
// module chunks = main